let timer: ReturnType<typeof setTimeout>;

const debounce = <Args extends unknown[]>(fn: (...args: Args) => void, ...args: Args) => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    fn(...args);
  }, 500);
};

export default debounce;
